<template>
  <div>
    <aside class="main-sidebar sidebar-dark sidebar-dark-brand-accent sidebar-no-expand ">
      <div class="brand-link">
        <img :src="theme.getMenuIcon()" alt="" class="brand-image" />
      </div>
      <div class="sidebar">
        <!-- Sidebar user panel -->
        <div class="user-panel mt-3 pb-3 mb-3 d-flex w-100">
          <div class="image pt-3">
            <img src="/images/user.jpg" class="img-circle" alt="User Image" />
          </div>
          <div class="info" style="padding-top: 0.65rem">
            <p class="d-block text-truncate" style="min-width: 8rem; max-width: 7.5rem">
              <small><strong>{{ user.username }}</strong></small><br />
              <small>{{ user.first_name }} {{ user.last_name }}</small>
            </p>
          </div>
          <!-- Tasto di logout -->
          <div class="info">
            <a @click.prevent="signOut" class="btn btn-text" style="padding: 0; padding-top: 0.5rem" href="#">
              <i class="fa fa-sign-out-alt" aria-hidden="true" title="Disconnetti"></i>
              <small class="d-block"> Esci</small>
            </a>
          </div>

        </div>

        <!-- Sidebar Menu -->
        <home-nav v-if="nav === 'home'"></home-nav>
        <company-nav v-if="nav === 'company'"></company-nav>
        <admin-nav v-if="nav === 'admin'"></admin-nav>
        <!-- /.sidebar-menu -->
      </div>
    </aside>
  </div>
</template>

<script setup>
import {useRouter} from "vue-router";
import useAuthStore from "@/stores/auth.store.js";
import useThemeStore from "@/stores/theme.store.js";
import HomeNav from "@/components/Sidebar/HomeNav.vue";
import AdminNav from "@/components/Sidebar/AdminNav.vue";
import CompanyNav from "@/components/Sidebar/CompanyNav.vue";

const props = defineProps(["nav"]);

const authStore = useAuthStore()
const router = useRouter()
const theme = useThemeStore()
const user = authStore.user

function signOut() {
  authStore.logout()
  router.replace({ name: "login" })
}
</script>

<style>
.main-sidebar .nav-link {
  --bs-nav-link-padding-x: 0.8rem;
}

.main-sidebar .accordion {
  --bs-accordion-btn-padding-y: 0.5rem;
  --bs-accordion-btn-padding-x: 1rem;
  --bs-accordion-body-padding-y: 0px;
  --bs-accordion-body-padding-x: 0px;
  --bs-accordion-border-width: 0px;
}

.main-sidebar.sidebar-dark .accordion {
  --bs-accordion-bg: #343a40;
  --bs-accordion-active-bg: #343a40;
  --bs-accordion-active-color: #d0d4db;
  --bs-accordion-btn-color: #d0d4db;
  --bs-accordion-color: #fff;
}

.main-sidebar.sidebar-dark .accordion-button::after {
  filter: brightness(10);
}

.main-sidebar.sidebar-dark {
  color: #c2c7d0;
}
</style>
